export const importRemoteModule = async ({ name, url, dependencies = {}, transformUrl, }) => {
    var _a;
    url = transformUrl ? transformUrl(url) : url;
    if (typeof window !== 'undefined' && ((_a = window.__REMOTE_PRELOAD) === null || _a === void 0 ? void 0 : _a[url])) {
        return window.__REMOTE_PRELOAD[url];
    }
    const requireHandler = (name) => {
        if (dependencies[name]) {
            return dependencies[name];
        }
        else {
            throw new Error(`[importRemoteModule] Module not found: ${name}`);
        }
    };
    const exports = {};
    const mod = { exports };
    if (typeof window === 'undefined') {
        const response = await fetch(url);
        const code = await response.text();
        const func = new Function('require', 'module', 'exports', code);
        func(requireHandler, mod, exports);
    }
    else {
        const loadScript = new Promise((resolve, reject) => {
            for (const dep in dependencies) {
                window[dep] = dependencies[dep];
            }
            const script = document.createElement('script');
            script.src = url;
            script.onload = () => {
                resolve(window[name]);
                document.head.removeChild(script);
            };
            script.onerror = () => {
                reject();
                document.head.removeChild(script);
            };
            document.head.appendChild(script);
        });
        mod.exports = await loadScript;
    }
    if (typeof window !== 'undefined') {
        window.__REMOTE_PRELOAD = window.__REMOTE_PRELOAD || {};
        window.__REMOTE_PRELOAD[url] = mod.exports;
    }
    return mod.exports;
};
export const createRemoteModule = (options) => {
    return (consumerOptions) => importRemoteModule(Object.assign(Object.assign({}, options), consumerOptions));
};
export const withSSR = (dynamic, importFn) => {
    const component = dynamic(importFn);
    if (typeof window !== 'undefined') {
        const spiedFn = window.__NEXT_PRELOADREADY;
        window.__NEXT_PRELOADREADY = (...args) => {
            return importFn()
                .then(() => {
                component.render.preload();
            })
                .catch(() => {
            })
                .finally(() => {
                return spiedFn ? spiedFn(...args) : Promise.resolve();
            });
        };
    }
    return component;
};
//# sourceMappingURL=remote-modules.js.map
// @zapier/universal-layout@9.14.1 (2aac35652)
